import { Clock } from 'lucide-react';

export default function SessionExpired() {
  return (
    <div className="provider-home relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-4">
      <div className="provider-home-bg pointer-events-none absolute inset-0" aria-hidden />
      <div className="provider-home-vignette pointer-events-none absolute inset-0" aria-hidden />

      <div className="provider-login-panel relative z-10 w-full max-w-md rounded-2xl p-8 text-center sm:p-10">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-tp-gold/40 bg-tp-gold/10">
          <Clock size={32} className="text-tp-gold" />
        </div>
        <h1 className="mt-6 font-display text-2xl font-bold uppercase tracking-wider text-white">
          Session Expired
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-white/65">
          Your game session has ended — usually because you signed in on another device or your session
          timed out. Close this tab and launch Teen Patti again from your casino app to continue playing.
        </p>
      </div>
    </div>
  );
}
